import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'prop-types';
import { useDealerDeal } from 'wallet-deals';
import { jsx } from 'react/jsx-runtime';
import useWalletSyncInitialization from './hooks/useWalletSyncInitialization.js';
import useUpdatePaymentsInfo from './hooks/useUpdatePaymentsInfo.js';
import useIcoTradeInInitialization from './hooks/useIcoTradeInInitialization.js';
import useKBBTradeInInitialization from './hooks/useKBBTradeInInitialization.js';
import useConfigureSDPEnv from './hooks/useConfigureSDPEnv.js';
import useWalletInitialization from './hooks/useWalletInitialization.js';
function ConnectedMyWalletModal(_ref) {
  let {
    container,
    // For Syndicated Wallet
    env = 'prod',
    // Part of SDP configuration
    vdpResultsDuck,
    inventoryDuck,
    paymentsDuck,
    dealsDuck,
    userDuck,
    interestRateDuck,
    currentPageNameDuck,
    tradeInFetcher,
    blockTradeInFetch,
    IcoFetcher,
    vrsServicesFetcher,
    creditVerificationFetcher,
    EmailOwnerFetcher,
    onSacaAppClick = () => {},
    onSearchByBudget = () => {},
    onSearchAvailVehicles = () => {},
    pageName,
    paymentFetcher,
    onClose = () => {},
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const [MyWalletModal, setMyWalletModal] = useState(null);
  const paymentsBudget = useSelector(paymentsDuck.selectors.getBudget);
  const listing = useSelector(state => {
    if (state?.currentPageName === 'vdp' && vdpResultsDuck) {
      return vdpResultsDuck.selectors.getActiveInventory(state)?.[0];
    }
    return null;
  }) || {};
  const {
    listingId: walletListingId,
    displayModal
  } = useSelector(paymentsDuck.selectors.getMyWallet);
  useWalletSyncInitialization({
    paymentsDuck
  });
  useUpdatePaymentsInfo({
    paymentsDuck
  });
  const {
    fetchIcoTradeIns
  } = useIcoTradeInInitialization({
    paymentsDuck
  });
  useKBBTradeInInitialization({
    paymentsDuck,
    blockTradeInFetch
  });
  useDealerDeal({
    paymentsDuck,
    dealsDuck
  });
  useConfigureSDPEnv({
    env
  });

  // wallet modal imports on click
  useEffect(() => {
    if (displayModal) {
      import(/* webpackChunkName: "MyWalletModal" */'./MyWalletModal.js').then(component => {
        if (component?.default) {
          setMyWalletModal(component.default);
        }
      });
    }
  }, [displayModal]);
  useWalletInitialization({
    paymentsDuck,
    listingId: listing?.id
  });
  const handleSearchByBudget = useCallback(async (maxPriceValue, walletPaymentOption) => {
    dispatch(paymentsDuck.creators.updateMyWallet({
      displayModal: false
    }));

    // TODO: SRP (NAVIGATE);
    onSearchByBudget({
      maxPrice: maxPriceValue,
      walletPaymentOption
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [onSearchByBudget]);
  const handleSearchAvailVehiclesClick = useCallback(async (event, walletPaymentOption) => {
    const maxPriceValue = event?.target?.value || paymentsBudget || 0;
    dispatch(paymentsDuck.creators.updateMyWalletInteractions({
      showMaxPriceAlert: true
    }));
    dispatch(paymentsDuck.creators.updatePaymentsInfo({
      budget: maxPriceValue
    }));
    await handleSearchByBudget(maxPriceValue, walletPaymentOption);
    await onSearchAvailVehicles(event);

    // TODO: implement tagging
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [handleSearchByBudget, paymentsBudget]);
  const handleReturnToVdpClick = useCallback(async event => {
    dispatch(paymentsDuck.creators.updateMyWallet({
      displayModal: false
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleModalClose = useCallback(async walletPaymentOption => {
    if (walletPaymentOption === 'lease') {
      handleSearchByBudget(null, walletPaymentOption);
    }
    onClose();
  }, [handleSearchByBudget, onClose]);
  const handleResetListingId = () => {
    dispatch(paymentsDuck.creators.updateMyWallet({
      listingId: null
    }));
    onClose();
  };

  // TODO: figure out why walletListingId was used instead of listing.id
  return MyWalletModal && /*#__PURE__*/jsx(MyWalletModal, {
    container: container,
    creditVerificationFetcher: creditVerificationFetcher,
    fetchIcoTradeIns: fetchIcoTradeIns,
    listingId: walletListingId || listing?.id,
    ownerId: listing?.owner?.id,
    isIcoDealer: listing?.owner?.isIcoDealer,
    onHideModal: handleResetListingId,
    onSearchAvailVehiclesClick: handleSearchAvailVehiclesClick,
    onReturnToVdpClick: handleReturnToVdpClick,
    onSacaAppClick: onSacaAppClick,
    onWalletClose: handleModalClose,
    inventoryDuck: inventoryDuck,
    paymentsDuck: paymentsDuck,
    dealsDuck: dealsDuck,
    userDuck: userDuck,
    interestRateDuck: interestRateDuck,
    currentPageNameDuck: currentPageNameDuck,
    vrsServices: vrsServicesFetcher,
    EmailOwnerFetcher: EmailOwnerFetcher,
    paymentFetcher: paymentFetcher,
    pageName: pageName,
    ...rest
  });
}
var ConnectedMyWalletModal$1 = /*#__PURE__*/React.memo(ConnectedMyWalletModal);
export { ConnectedMyWalletModal$1 as default };
